import React from 'react';
import SEO from './SEO';

const pillars = [
  {
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
      </svg>
    ),
    title: 'Research-First',
    desc: 'We build what we research. Every product ships from real engineering work, not prototypes.',
  },
  // {
  //   icon: (
  //     <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064" />
  //     </svg>
  //   ),
  //   title: 'Global Team',
  //   desc: 'Independent ML engineers across USA, India and Singapore — distributed by design.',
  // },
  {
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-2 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    ),
    title: 'Enterprise Grade',
    desc: 'Production-ready from day one. Multi-tenant, scalable, and built for real workloads.',
  },
];

const About = () => {
  return (
    <>
      <SEO
        title="About"
        path="/about"
        description="InjectAI Labs is an AI research company with a global distributed team. We research and ship production-ready AI for enterprise platforms."
      />
      <section id="about" className="py-24 pt-36 bg-dark-light">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">

          {/* Left */}
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-secondary/10 border border-secondary/20 rounded-full text-xs text-secondary font-medium mb-6 uppercase tracking-widest">
              About
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
              We Research.<br />We Ship.
            </h2>
            <p className="text-gray-400 text-lg leading-relaxed mb-6">
              InjectAI Labs is an AI research company focused on building production-ready AI that integrates into existing enterprise platforms — without requiring a full rebuild.
            </p>
            <p className="text-gray-400 leading-relaxed">
              Our work starts in research and ends in deployment. We ship modules that solve real problems: knowledge retrieval, content understanding, and intelligent automation — available as plugins and APIs for the platforms enterprises already use.
            </p>
          </div>

          {/* Right — pillars */}
          <div className="flex flex-col gap-5">
            {pillars.map((p, i) => (
              <div key={i} className="flex items-start gap-4 p-5 bg-dark rounded-2xl border border-gray-800">
                <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center text-primary flex-shrink-0">
                  {p.icon}
                </div>
                <div>
                  <h3 className="font-semibold text-white mb-1">{p.title}</h3>
                  <p className="text-gray-400 text-sm leading-relaxed">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
    </>
  );
};

export default About;
